import logo from "../assets/logo.png";

export default function NavBar({ activeTab, setActiveTab }) {
  return (
    <div className="navBar">
      <img src={logo} className="logo" />
      <div className="navTab">
        <p
          className={activeTab === "home" ? "active" : ""}
          onClick={() => setActiveTab("home")}
        >
          Home
        </p>

        {/* <p
          className={activeTab === "services" ? "active" : ""}
          onClick={() => setActiveTab("services")}
        >
          Services
        </p> */}

        <p
          className={activeTab === "contact" ? "active" : ""}
          onClick={() => setActiveTab("contact")}
        >
          Contact
        </p>
      </div>
    </div>
  );
}
